import {
    MOVE_TO_ANOTHER_ACCOUNT_REQUEST,
    MOVE_TO_ANOTHER_ACCOUNT_RESULT,
    MOVE_TO_ANOTHER_ACCOUNT_OPEN_MODAL,
    MOVE_TO_ANOTHER_ACCOUNT_CLOSE_MODAL,
    MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST,
    MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_RESULT,
    MOVE_TO_ANOTHER_ACCOUNT_SET_DEVICE,
} from 'Redux/actionTypes';

export const moveToAnotherAccountRequest = (data) => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_REQUEST,
    payload: data
})

export const moveToAnotherAccountResult = (result) => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_RESULT,
    payload: result
})

export const moveToAnotherAccountOpenModal = (items) => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_OPEN_MODAL,
    payload: items
})

export const moveToAnotherAccountCloseModal = () => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_CLOSE_MODAL
})

export const moveToAnotherAccountGetKeyFobRequest = (item) => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST,
    payload: item 
})

export const moveToAnotherAccountGetKeyFobResult = (result) => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_RESULT,
    payload: result
})

export const moveToAnotherAccountSetDevice = (device) => ({
    type: MOVE_TO_ANOTHER_ACCOUNT_SET_DEVICE,
    payload: device
})